import { Button, Code, SimpleGrid, TextInput, Modal, Text, Center, Select } from '@mantine/core';
import { useForm, yupResolver } from '@mantine/form';
import { useState } from 'react';
import dayjs from 'dayjs';
import { useDisclosure } from '@mantine/hooks';

import useCreate from './useCreate';

import { object, string } from "yup";
import { DateTimePicker } from '@mantine/dates';
const userSchema = object().shape({
    heading_en: string()
        .required("Heading is required")
        .min(3, "Heading must be at least 3 characters"),
    description_en: string()
        .required("Description is required")
        .min(3, "Description must be at least 3 characters"),


});

const userTypeData = [
    { value: 'all', label: 'All' },
    { value: 'premium-without-agencies', label: 'Premium users without agencies' },
    { value: 'premium-with-agencies', label: 'Premium users with agencies' },
    { value: 'free', label: 'Free users' },
    // { value: 'pro', label: 'Pro users' },
    { value: 'premium', label: 'Premium users' },
];

function CreateNotification() {
    const {
        createMutation
    } = useCreate()


    const [submittedValues] = useState('');

    const form = useForm({
        initialValues: {
            heading: "",
            description: "",
        },
        validate: yupResolver(userSchema)
    });
    const handleCreate = form.onSubmit(async (values) => {

        const formData = new FormData();
        formData.append("user_type", values?.user_type);
        formData.append("schedule_time", dayjs(values?.schedule_time).utc().format('YYYY-MM-DD HH:mm:ss'));
        formData.append("heading_en", values?.heading_en);
        values?.heading_de == null || formData.append("heading_de", values?.heading_de);
        values?.heading_it == null || formData.append("heading_it", values?.heading_it);
        values?.heading_fr == null || formData.append("heading_fr", values?.heading_fr);
        values?.heading_es == null || formData.append("heading_es", values?.heading_es);
        values?.heading_pt == null || formData.append("heading_pt", values?.heading_pt);
        values?.heading_nl == null || formData.append("heading_nl", values?.heading_nl);
        values?.heading_ar == null || formData.append("heading_ar", values?.heading_ar);
        values?.description_en == null || formData.append("description_en", values?.description_en);
        values?.description_de == null || formData.append("description_de", values?.description_de);
        values?.description_it == null || formData.append("description_it", values?.description_it);
        values?.description_fr == null || formData.append("description_fr", values?.description_fr);
        values?.description_es == null || formData.append("description_es", values?.description_es);
        values?.description_pt == null || formData.append("description_pt", values?.description_pt);
        values?.description_nl == null || formData.append("description_nl", values?.description_nl);
        values?.description_ar == null || formData.append("description_ar", values?.description_ar);
        createMutation.mutate(formData)
    })
    const { file } = form.values
    const date = new Date();
    date.setMinutes(date.getMinutes() + 10);

    const [opened, { open, close }] = useDisclosure(false);


    return (
        <>
            <h1>Create New Notification</h1>

            <SimpleGrid cols={2}>
                <Select
                    label="User Type"
                    placeholder="Pick one"
                    searchable
                    data={userTypeData}
                    nothingFound="No items found"
                    clearable
                    {...form.getInputProps("user_type")}
                />

                <DateTimePicker label="Schedule date and time (After 10 minutes from now)" placeholder="Pick date and time" timeFormat="h:mm aa" {...form.getInputProps("schedule_time")} withMinutesStep={5}
                    dateFormat="yyyy-MM-dd HH:mm"
                    minDate={date} />
                <TextInput
                    label="Heading English"
                    placeholder="Enter Heading"
                    key={form.key('heading')}
                    style={{ alignSelf: "baseline" }}
                    {...form.getInputProps('heading_en')}
                />
                <TextInput
                    label="Message English"
                    placeholder="Enter Message"
                    key={form.key('description_en')}
                    style={{ alignSelf: "baseline" }}
                    {...form.getInputProps('description_en')}
                />
                <TextInput
                    label="Heading French"
                    placeholder="Enter heading"
                    key={form.key('heading_fr')}
                    style={{ alignSelf: "baseline" }}
                    {...form.getInputProps('heading_fr')}
                />
                <TextInput
                    label="Message French"
                    placeholder="Enter Message"
                    key={form.key('description_fr')}
                    style={{ alignSelf: "baseline" }}
                    {...form.getInputProps('description_fr')}
                />
                <TextInput
                    label="Heading Italian"
                    placeholder="Enter heading"
                    key={form.key('heading_it')}
                    style={{ alignSelf: "baseline" }}
                    {...form.getInputProps('heading_it')}
                />

                <TextInput
                    label="Message Italian"
                    placeholder="Enter Message"
                    key={form.key('description_it')}
                    style={{ alignSelf: "baseline" }}
                    {...form.getInputProps('description_it')}
                />

                <TextInput
                    label="Heading Spanish"
                    placeholder="Enter heading"
                    key={form.key('heading_es')}
                    style={{ alignSelf: "baseline" }}
                    {...form.getInputProps('heading_es')}
                />
                <TextInput
                    label="Message Spanish"
                    placeholder="Enter Message"
                    key={form.key('description_es')}
                    style={{ alignSelf: "baseline" }}
                    {...form.getInputProps('description_es')}
                />
                <TextInput
                    label="Heading German"
                    placeholder="Enter heading"
                    key={form.key('heading_de')}
                    style={{ alignSelf: "baseline" }}
                    {...form.getInputProps('heading_de')}
                />
                <TextInput
                    label="Message German"
                    placeholder="Enter Message"
                    key={form.key('description_de')}
                    style={{ alignSelf: "baseline" }}
                    {...form.getInputProps('description_de')}
                />

                <TextInput
                    label="Heading Portuguese"
                    placeholder="Enter heading"
                    key={form.key('heading_pt')}
                    style={{ alignSelf: "baseline" }}
                    {...form.getInputProps('heading_pt')}
                />

                <TextInput
                    label="Message Portuguese"
                    placeholder="Enter Message"
                    key={form.key('description_pt')}
                    style={{ alignSelf: "baseline" }}
                    {...form.getInputProps('description_pt')}
                />

                <TextInput
                    label="Heading Dutch"
                    placeholder="Enter heading"
                    key={form.key('heading_nl')}
                    style={{ alignSelf: "baseline" }}
                    {...form.getInputProps('heading_nl')}
                />


                <TextInput
                    label="Message Dutch"
                    placeholder="Enter Message"
                    key={form.key('description_nl')}
                    style={{ alignSelf: "baseline" }}
                    {...form.getInputProps('description_nl')}
                />

                <TextInput
                    label="Heading Arabic"
                    placeholder="Enter heading"
                    key={form.key('heading_ar')}
                    style={{ alignSelf: "baseline" }}
                    {...form.getInputProps('heading_ar')}
                />


                <TextInput
                    label="Message Arabic"
                    placeholder="Enter Message"
                    key={form.key('description_ar')}
                    style={{ alignSelf: "baseline" }}
                    {...form.getInputProps('description_ar')}
                />




            </SimpleGrid>




            <br></br>



            <div />

            <Button type="submit" mt="md" onClick={handleCreate} loading={createMutation?.isPending}>
                Submit
            </Button>
            &nbsp;
            <Button type="button" mt="md" color="red" onClick={open} >
                Return
            </Button>

            <Modal opened={opened} onClose={close}
                centered
                title="Confirm">

                <Text>Are you sure you want to leave this page without saving?</Text>


                <Center mt={"md"}>
                    <Button onClick={() => window.history.back()}
                    >Confirm</Button>
                </Center>

            </Modal >

            {submittedValues && (
                <Code block mt="md">
                    {submittedValues}
                </Code>
            )}
        </>
    );
}



export default CreateNotification;
